export const anexo7_item = [
  {
    ejercicio : "2026",
    items_anexos : [
      {
        anexos_item_nombre: " SEGUNDO TRIMESTRE",
        anexos_item_url: "../../../contenido/informacion/ANEXO 7CAF 2do trim 2026.pdf"
      },
      {
        anexos_item_nombre: " PRIMER TRIMESTRE",
        anexos_item_url: "../../../contenido/informacion/ANEXO 7CAF 1er trim 2026.pdf"
      }
    ]
  },
  {
    ejercicio : "2025",
    items_anexos : [
      {
        anexos_item_nombre: " QUINTO TRIMESTRE",
        anexos_item_url: "../../../contenido/informacion/ANEXO 7CAF 5to trim 2025.pdf"
      },
      {
        anexos_item_nombre: " CUARTO TRIMESTRE",
        anexos_item_url: "../../../contenido/informacion/ANEXO 7CAF 4to trim 2025.pdf"
      },
      {
        anexos_item_nombre: " TERCER TRIMESTRE",
        anexos_item_url: "../../../contenido/informacion/ANEXO 7CAF 3trim 2025.pdf"
      },
      {
        anexos_item_nombre: " SEGUNDO TRIMESTRE",
        anexos_item_url: "../../../contenido/informacion/Anexo7CAF2dotrim2025.pdf"
      },
      {
        anexos_item_nombre: " PRIMER TRIMESTRE",
        anexos_item_url: "../../../contenido/informacion/Anexo 7CAF 1er trim 2025.pdf"
      }
    ]
  },
  {
    ejercicio : "2024",
    items_anexos : [
      {
        anexos_item_nombre: " CIERRE DEL EJERCICIO 2024",
        anexos_item_url: "../../../contenido/informacion/Anexo 7CAF Cierre 2024.pdf"
      },
      {
        anexos_item_nombre: " CUARTO TRIMESTRE",
        anexos_item_url: "../../../contenido/informacion/Anexo 7CAF 4trim 2024.pdf"
      },
      {
        anexos_item_nombre: " TERCER TRIMESTRE",
        anexos_item_url: "../../../contenido/informacion/Anexo 7CAF 3trim 2024.pdf"
      },
      {
        anexos_item_nombre: " SEGUNDO TRIMESTRE",
        anexos_item_url: "../../../contenido/informacion/Anexo 7CAF 2trim 2024.pdf"
      },
      {
        anexos_item_nombre: " INSABI PRIMER TRIMESTRE",
        anexos_item_url: "../../../contenido/informacion/anexo 7 1er trim 2024.pdf"
      }
    ]
  },
  {
    ejercicio : "2023",
    items_anexos : [
      {
        anexos_item_nombre: " INSABI CUARTO TRIMESTRE",
        anexos_item_url: "../../../contenido/informacion/Anexo 7CAF-4to trimestre.pdf",
      },
      {
        anexos_item_nombre: " INSABI TERCER TRIMESTRE",
        anexos_item_url: "../../../contenido/informacion/ANEXO 7CAF 3er.pdf",
      },
      {
        anexos_item_nombre: " INSABI SEGUNDO TRIMESTRE",
        anexos_item_url: "../../../contenido/informacion/7CAE 2do trimestre.pdf",
      },
      {
        anexos_item_nombre: " INSABI PRIMER TRIMESTRE",
        anexos_item_url: "../../../contenido/informacion/HGO-2023-ANEZO 7 CAF 1ER TRIMESTRE 2023.pdf",
      }
    ]
  },
  {
    ejercicio : "2022",
    items_anexos : [
      {
        anexos_item_nombre: " INSABI EJERCICIO 2022 (CIERRE)",
        anexos_item_url: "../../../contenido/informacion/INSABI-2022-CIERRE-INSUMOS ANEXO 7 CAF.pdf",
      },
      {
        anexos_item_nombre: " INSABI CUARTO TRIMESTRE",
        anexos_item_url: "../../../contenido/informacion/publicaciones/ANEXO 7CAF4trim.pdf",
      },
      {
        anexos_item_nombre: " INSABI TERCER TRIMESTRE",
        anexos_item_url: "../../../contenido/informacion/publicaciones/ANEXO 7CAF-3ER TRIMESTRE.pdf",
      },
      {
        anexos_item_nombre: " INSABI SEGUNDO TRIMESTRE",
        anexos_item_url: "../../../contenido/informacion/publicaciones/ANEXO 7 CAF 2DO TRIMESTRE.pdf",
      },
      {
        anexos_item_nombre: " INSABI PRIMER TRIMESTRE",
        anexos_item_url: "../../../contenido/informacion/publicaciones/ANEXO 7CAF-2022 (ENERO-MARZO).pdf",
      }
    ]
  },
  {
    ejercicio : "2021",
    items_anexos : [
      {
        anexos_item_nombre: " INSABI CIERRE EJERCICIO 2021",
        anexos_item_url: "../../../contenido/informacion/publicaciones/ANEXO 7CAF-CIERRE EJERCICIO 2021.pdf",
      }
    ]
  }
];
